const defaultRetryDelayMs = 500
const defaultRequestAttempts = 2

const wait_for_retry = (delayMs) => {
    return new Promise((resolve) => window.setTimeout(resolve, delayMs))
}

export const is_retryable_request_error = (error) => {
    const responseStatus = error?.response?.status

    return !responseStatus || responseStatus === 429 || responseStatus >= 500
}

export const request_with_retry = async (request, options = {}) => {
    const attempts = options.attempts || defaultRequestAttempts
    const delayMs = options.delayMs ?? defaultRetryDelayMs
    const wait = options.wait || wait_for_retry

    for (let attempt = 1; attempt <= attempts; attempt += 1) {
        try {
            return await request()
        } catch (error) {
            const shouldRetry = attempt < attempts && is_retryable_request_error(error)

            if (!shouldRetry) {
                throw error
            }

            await wait(delayMs * attempt)
        }
    }
}
